import type {
  APIResponse,
  MatterShareFolder,
  MatterShareFolderFile,
} from "@/lib/types";
import {
  authenticatedFastApiAxiosInstance,
  publicFastApiAxiosInstance,
} from "../../http";
import { baseFastApiMatterRoute } from "./matter";

export type CreateMatterShareFolderPayload = {
  matterId: string;
  label: string;
  expirationDate: string;
  contactConnections: Array<{
    contactId: string;
    label: string;
  }>;
};

export const createMatterShareFolder = (
  data: CreateMatterShareFolderPayload,
) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MatterShareFolder>>("matters/v4/share-folders", {
      matterId: data.matterId,
      label: data.label,
      expirationDate: data.expirationDate,
      connections: data.contactConnections.map(({ contactId }) => ({
        targetObjectId: contactId,
        targetObjectType: "contact",
        connectionType: "matter_share_folder_to_recipient",
      })),
    })
    .then((res) => res.data);
};

export type AccessMatterShareFolderResponseData = {
  fileName: string | null;
  presignedUrlKey: string | null;
};

export const accessMatterShareFolder = (data: {
  shareFolderPasscode: string;
}) => {
  return publicFastApiAxiosInstance
    .get<
      APIResponse<AccessMatterShareFolderResponseData[]>
    >(`matters/v4/share-folders/${data.shareFolderPasscode}`)
    .then((res) => res.data);
};

export const deleteMatterShareFolder = (data: {
  shareFolderId: string;
  matterId: string;
}) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterShareFolder>
    >(`${baseFastApiMatterRoute}/share-folders/${data.shareFolderId}`)
    .then((res) => res.data);
};

export const createMatterShareFolderFile = (data: {
  fileId: string;
  matterId: string;
  shareFolderId: string;
}) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterShareFolderFile>
    >(`${baseFastApiMatterRoute}/share-folders/files`, data)
    .then((res) => res.data);
};

export const deleteMatterShareFolderFile = (data: {
  id: string;
  matterId: string;
}) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterShareFolderFile>
    >(`${baseFastApiMatterRoute}/share-folders/files/${data.id}`)
    .then((res) => res.data);
};
